import { msalAuthProvider, msalHttpClient, msalRefreshAuth } from 'ra-auth-msal';
import { getIdentityFromAccount, getPermissionsFromAccount, loginRequest, msalConfig, tokenRequest } from './authConfig';
import { PublicClientApplication } from "@azure/msal-browser";

export const redirectOnCheckAuth = true;

export const msalInstance = new PublicClientApplication(msalConfig);

export const authProvider = msalAuthProvider({
  msalInstance,
  loginRequest,
  tokenRequest,
  getPermissionsFromAccount,
  getIdentityFromAccount,
  redirectOnCheckAuth,
});

